// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import _ from 'lodash';
import { axios } from "./axios";
import { showSuccess, showError } from "../actions/globalActions";
import cookie from "../utils/cookie";
import { toast } from 'sonner';

const baseUrl = `${process.env.API_URL}/api/v1`;

const createAuthHeader = (token) => {
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const useTimeSlotStore = create(immer((set) => ({
  timeSlots: [],

  // Asynchronous actions
  getTimeSlotsByLocation: async (leagueName) => {
    try {
      const { data } = await axios.get(`${baseUrl}/timeSlots/location/${leagueName}`);
      set((state) => {
        state.timeSlots = data.result;
      });
    } catch (error) {
      console.error("Error in getTimeSlotsByLocation:", error);
    }
  },
  
  getTimeSlotsByLeagueName: async (leagueName) => {
    try {
      const { data } = await axios.get(`${baseUrl}/timeSlots/organizationName/${leagueName}?include=location.parentLocation`);
      set((state) => {
        state.timeSlots = data.result;
      });
    } catch (error) {
      console.error("Error in getTimeSlotsByLeagueName:", error);
    }
  },

  getTimeSlotsByLeagueId: async (leagueId) => {
    try {
      // Route is /league/:leagueId (a "season" IS a League) — the old
      // /season/ path never existed and 404'd, so the season scheduler always
      // saw zero time slots. Same include as the tournament variant.
      const { data } = await axios.get(`${baseUrl}/timeSlots/league/${leagueId}?include=location.parentLocation`);
      set((state) => {
        state.timeSlots = data.result;
      });
    } catch (error) {
      console.error("Error in getTimeSlotsByLeagueId:", error);
    }
  },

  getTimeSlotsByTournamentId: async (tournamentId) => {
    try {
      const { data } = await axios.get(`${baseUrl}/timeSlots/tournament/${tournamentId}?include=location.parentLocation`);
      set((state) => {
        state.timeSlots = data.result;
      });
    } catch (error) {
      console.error("Error in getTimeSlotsByTournamentId:", error);
    }
  },

  updateTimeSlots: (getToken) => {
    return async (timeSlot) => {
      try {
        const token = await getToken();
        const { data } = await axios.put(`${baseUrl}/timeSlots/${timeSlot._id}`, timeSlot, createAuthHeader(token));
        const { result, status, error } = data;
        console.log("updateTimeSlots result: ", result, status, error);
        error ? toast.error(error) : toast.success(`Successfully Updated!`);  
        set((state) => {
          const index = state.timeSlots.findIndex(d => d._id === timeSlot._id);
          if (index !== -1 && result) {
            // Ensure the result has the _id
            const updatedSlot = result._id ? result : { ...result, _id: timeSlot._id };
            state.timeSlots[index] = updatedSlot;
          }
        });
        
        return { error, result, status };
      } catch (error) {
        showError("Error", "Update Error");
        console.error("Error in updateTimeSlots:", error);
        return { error: "Failed to update time slot" };
      }
    }
  },

  // INT-0027 quick availability: slots for a competition in one call; the
  // API also places the competition's time-less games. Callers refetch.
  quickAvailability: (getToken) => {
    return async (payload) => {
      try {
        const token = await getToken();
        const { data } = await axios.post(`${baseUrl}/timeSlots/quick-availability`, payload, createAuthHeader(token));
        const { error, result, status } = data;
        return { error, result, status };
      } catch (error) {
        const message = error?.response?.data?.error || 'Could not set up availability';
        console.error('Error in quickAvailability:', error);
        return { error: message };
      }
    };
  },

  addTimeSlot: (getToken) => {
    return async (timeSlot) => {
      try {
        const token = await getToken();
        const { data } = await axios.post(`${baseUrl}/timeSlots`, timeSlot, createAuthHeader(token));
        const { error, result, status } = data;
        error ? toast.error(error) : toast.success(`Successfully Updated!`);  
        set((state) => {
          if (result) {
            state.timeSlots.push(result);
          }
        });
        
        return { error, result, status };
      } catch (error) {
        showError("Error", "Add Error");
        console.error("Error in addTimeSlot:", error);
        return { error: "Failed to add time slot" };
      }
    }
  },

  deleteTimeSlot: (getToken) => {
    return async (id) => {
      try {
        const token = await getToken();
        const { data } = await axios.delete(`${baseUrl}/timeSlots/${id}`, createAuthHeader(token));
        const { error, result, status } = data;
        error ? toast.error(error) : toast.success(`Successfully Deleted!`);  
        set((state) => {
          state.timeSlots = state.timeSlots.filter(slot => slot._id !== id);
        });
        return { error, result, status };
      } catch (error) {
        showError("Error", "Delete Error");
        console.error("Error in deleteTimeSlot:", error);
        return { error: "Failed to delete time slot" };
      }
    }
  },

})));

export default useTimeSlotStore;